class TMv_RTAM_SearchFlyout {

	search_field 		= null;
	search_results 		= null;

	constructor(element, params)
	{

		this.element = element;

		this.search_field = this.element.querySelector(".q_row input");
		this.search_results = this.element.querySelector('.search_form_results');

		this.element.addEventListener('focusout', this.focusOutHandler.bind(this));

		this.search_field.addEventListener('focus', this.searchFieldFocus.bind(this));

	}

	searchFieldFocus() {
		this.element.classList.add('search_showing');

	}

	/**
	 * Handles when this entire flyout loses focus, and we need to confirm that are no longer in the element, then hide and revert
	 * @param event
	 */
	focusOutHandler(event) {

		let flyout_element = event.relatedTarget?.closest('.TMv_RTAM_SearchFlyout');

		if(!flyout_element)
		{
			this.element.classList.remove('search_showing');

			// Empty the search results
			// this.search_field.value = '';
			// this.search_field.dispatchEvent(new Event('input'));
			// this.search_results.innerHTML = '';
		}

	}
}